angular.module('bb.appointments').directive('notifyBy', () => {
  return {
    restrict: 'E',
    scope: {
      initial: '=',
      current: '=',
    },
    controller() {
      const vm = this;
      const notify = ['email', 'text', 'office'];
      this.$onInit = function () {
        if (vm.initial) {
          vm.diff = notify.reduce(
            (acc, key) => acc || vm.initial[key] !== vm.current[key],
            false,
          );
        }
      };
    },
    controllerAs: 'vm',
    bindToController: true,
    template: `<div>
                <span style="font-weight: bold;">Notify by:</span>
                <span style="margin-right: 0;" ng-if="vm.current.text">SMS</span>
                <span style="margin-right: 0;" ng-if="vm.current.text && vm.current.email"> & </span>
                <span style="margin-right: 0;" ng-if="vm.current.email">Email</span>
                <span style="margin-right: 0;" ng-if="vm.current.phone">Phone</span>
                <span style="margin-right: 0;" ng-if="vm.current.office">Office</span>
                <span ng-if="vm.diff" style="margin-right: 0; color: red; font-size:12px">(Overridden)</span>
            </div>`,
  };
});
